/*
  Zoeken in de header-dropdown: uitverkocht tonen en spelling verbeteren.

  De dropdown haalt zijn resultaten zelf op vanuit theme.js, met een fetch naar
  /search/suggest die de sectie predictive-search rendert. Die fetch onderscheppen
  we hier, zodat theme.js niet aangepast hoeft te worden. Twee dingen gebeuren:

  1. options[unavailable_products]=last meesturen, anders verdwijnen seizoens-
     producten buiten hun seizoen volledig uit de suggesties.
  2. Levert de zoekterm niets op, dan de spelling verbeteren en opnieuw ophalen,
     met een melding boven de resultaten. Dezelfde correctie als op de zoekpagina.

  Moet vroeg draaien, dus zonder defer laden en voor theme.js.
*/
(function () {
  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function' || typeof DOMParser === 'undefined') return;

  var TYPO_ASSET = window.theme && window.theme.assets && window.theme.assets.searchTypo;
  var typoLoader = null;

  /* De woordenlijst weegt 10 KB, dus pas ophalen als er echt niets gevonden is. */
  function loadTypo() {
    if (window.AngeloTypo) return Promise.resolve(window.AngeloTypo);
    if (!TYPO_ASSET) return Promise.resolve(null);
    if (!typoLoader) {
      typoLoader = new Promise(function (resolve) {
        var s = document.createElement('script');
        s.src = TYPO_ASSET;
        s.onload = function () { resolve(window.AngeloTypo || null); };
        s.onerror = function () { resolve(null); };
        document.head.appendChild(s);
      });
    }
    return typoLoader;
  }

  function withOption(url, key, value) {
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }

  function queryOf(url) {
    var m = /[?&]q=([^&]*)/.exec(url);
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
  }

  /*
    De sectie rendert de container data-search-results alleen als er producten
    zijn. Niet op /products/ in de HTML testen: de lege staat toont populaire
    producten en collectie-suggesties, dus die link staat er dan ook.
  */
  function hasProducts(html) {
    return html.indexOf('data-search-results') !== -1;
  }

  function asResponse(html, original) {
    return new Response(html, {
      status: original.status,
      statusText: original.statusText,
      headers: original.headers
    });
  }

  /* Melding bovenaan de dropdown, met dezelfde tekst als op de zoekpagina. */
  function withNotice(html, was, nu) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var host = doc.querySelector('#predictive-search-results');
      if (!host) return html;

      var note = doc.createElement('p');
      note.className = 'predictive-search__correction';
      var sterk = doc.createElement('b');
      sterk.textContent = nu;
      note.appendChild(doc.createTextNode('Geen resultaten voor "' + was + '", we tonen '));
      note.appendChild(sterk);
      note.appendChild(doc.createTextNode('.'));
      host.insertBefore(note, host.firstChild);

      var section = doc.querySelector('#shopify-section-predictive-search');
      return section ? section.outerHTML : doc.body.innerHTML;
    } catch (e) {
      return html;
    }
  }

  window.fetch = function (input, init) {
    var isRequest = typeof Request !== 'undefined' && input instanceof Request;
    var url;

    try {
      url = isRequest ? input.url : String(input);
    } catch (e) {
      return nativeFetch.call(this, input, init);
    }

    if (url.indexOf('/search/suggest') === -1) {
      return nativeFetch.call(this, input, init);
    }

    if (url.indexOf('unavailable_products') === -1) {
      url = withOption(url, 'resources[options][unavailable_products]', 'last');
    }

    /*
      Tags meezoeken in de dropdown. Standaard doorzoekt /search/suggest alleen
      titel, product_type, vendor en varianttitel, dus alle Nederlandse namen die
      als tag op de producten staan (custom.nederlandse_naam gespiegeld naar tags)
      waren hier onvindbaar terwijl de zoekpagina ze wél vond. Gemeten 2026-07-29:
      "statice" gaf 0 in de dropdown en 6 op de zoekpagina, "klaproos" 0 tegen 16,
      "strobloem" 0 tegen 11, "viooltje" 0 tegen 10.
    */
    if (url.indexOf('][fields]') === -1) {
      url = withOption(url, 'resources[options][fields]', 'title,product_type,variants.title,vendor,tag');
    }

    var self = this;
    var vraag = queryOf(url);

    return nativeFetch.call(self, url, init).then(function (res) {
      if (!res.ok) return res;

      return res.clone().text().then(function (html) {
        if (hasProducts(html) || !vraag) return asResponse(html, res);

        return loadTypo().then(function (typo) {
          /*
            Meerdere pogingen op volgorde: eerst de spelling, dan de woordgrenzen
            ("een jarig" naar "eenjarig"), en pas als laatste alleen het kernwoord
            ("stokroos zaad" naar "stokroos"). Zie search-typo.js voor de regels.
            De eerste poging die echt producten rendert wint; levert geen enkele
            iets op, dan blijft de oorspronkelijke lege staat staan.
          */
          var pogingen = typo && typo.kandidaten ? typo.kandidaten(vraag).slice(0, 3) : [];
          if (!pogingen.length) return asResponse(html, res);

          function probeer(i) {
            if (i >= pogingen.length) return asResponse(html, res);

            var fix = pogingen[i];
            var retry = url.replace(/([?&]q=)[^&]*/, '$1' + encodeURIComponent(fix));

            return nativeFetch.call(self, retry, init)
              .then(function (r2) { return r2.ok ? r2.text() : null; })
              .then(function (html2) {
                if (!html2 || !hasProducts(html2)) return probeer(i + 1);
                return asResponse(withNotice(html2, vraag, fix), res);
              })
              .catch(function () { return asResponse(html, res); });
          }

          return probeer(0);
        });
      });
    });
  };
})();
